// ResetEditorPlugin.tsx
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getRoot, LexicalEditor } from "lexical";
import { useEffect } from "react";

export function clearEditor(editor: LexicalEditor): void {
  editor.update(() => {
    const root = $getRoot();
    root.clear();
    root.append($createParagraphNode());
  });
}

export function ResetEditorPlugin({ registerReset }: { registerReset: (fn: () => void) => void }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    registerReset(() => clearEditor(editor));
  }, [editor, registerReset]);

  return null;
}
